import {useDroppable} from '@dnd-kit/core';

export function Droppable(props: { children: React.ReactNode, disabled?: boolean, fromMobile?: boolean}) {
  const {isOver, setNodeRef} = useDroppable({
    id: "Cart",
    data: {
      accepts: ['fromShop'],
    },
  });
  
  
  return (
    <div 
      ref={setNodeRef}
      className={props.fromMobile ? `w-full h-full ${isOver ? 'bg-[#639C6E]' : 'bg-[#92BA9A]'}` : `flex-1 overflow-y-scroll overflow-x-hidden px-2`}
    >
      {isOver && !props.fromMobile && !props.disabled ?
        <div className='h-full bg-green-100 border-2 border-primary border-dashed rounded-xl flex justify-center items-center'>
          <p className='font-bold text-2xl text-primary opacity-50'>AJOUTER</p>
        </div>
      : 
       props.children
      }
    </div>
  );
}